export default "__VITE_ASSET__Cn2LBfdF__";